import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import axios from 'axios'
import api from '../../components/api'
//import { useTabelaGestao } from '../context/GestaoPendenciasContext'
import moment from 'moment'

import { useEnunciadoContext } from '../../context/enunciadoContext'
import { useVerificaDesafioContext } from '../../context/verificaDesafioContext'
import { useSecaoEnunciadoContext } from '../../context/secaoEnunciadoContext'

import StatusValidacaoSecao from '../StatusValidacaoSecao'


const ClimaPlanilha = (props) => {

    var ano = props.ano
    var adesao_institucional_id = props.adesao_institucional_id
    var formulario_id = props.formulario_id

    var linkAPI = process.env.REACT_APP_API



    var [tipoInventario, setTipoInventario] = useState()

    var [statusProcessamentoArquivo, setStatusProcessamentoArquivo] = useState('Não enviado')
    var [nomeArquivo, setNomeArquivo] = useState('')
    var [file, setFile] = useState('')
    var [hospClima_id, setHospClima_id] = useState()
    

    var { enunciado, setEnunciado } = useEnunciadoContext()
    var { setSecaoEnunciado } = useSecaoEnunciadoContext()
    var { verificaDesafio } = useVerificaDesafioContext()

    const [questao1, setQuestao1] = useState()
    const [questao2, setQuestao2] = useState()

    const [totalPendencias, setTotalPendencias] = useState(0)


    useEffect(() => {

        verificaValidacoes()

    }, [hospClima_id, verificaDesafio, formulario_id])


    const verificaValidacoes = () => {



        setQuestao1()
        setQuestao2()
        

        if (hospClima_id) {

            var dataPost = {

                formulario_id: hospClima_id,
                desafio: 'Clima',

            }

            api.post('desafioValidaVarios', dataPost).then((result) => {


                var data = result.data
                console.log(data)

                var totalErros = 0

                for (var k = 0; k < data.length; k++) {

                    if (data[k].status == 'Erro') {


                        switch (data[k].enunciado) {

                          

                             case 'Tipo de inventário':

                                totalErros = totalErros + 1
                                setQuestao1('red')
                                

                            break

                            case 'Planilha atual':

                                totalErros = totalErros + 1
                                setQuestao2('red')
                                

                            break

                        }

                    }

                }

                setTotalPendencias(totalErros)

            }).catch((err) => {

                console.log(err.response)

            })

        }


    }




    function processaPlanilhaGHG() {


        window.$.confirm({
			//icon: 'fa fa-question',
            theme: 'material',
            closeIcon: true,
            animation: 'scale',
            type: 'green',
		    title: 'Confirmação',
		    content: 'Confirma processar a planilha?',
		    buttons: {
		        Sim: function () {

                    //console.log(dataPost)

                    var headers = {

                        'Content-type': 'application/json',
                        'x-access-token': '!nf0$@ud#2'

                    }

                    var dataPost = {

                        "proc_id": null,
                        "adesao_institucional_id": adesao_institucional_id,
                        "ano": ano,
                        "nomeArquivo": nomeArquivo


                    }

                    console.log(dataPost)
                    //return false

                    
                    axios.post(`https://api3.hospitaissaudaveis.org/verifica`, dataPost, {headers: headers}).then((result) => {

                        console.log(result.data)

                        if (result.data[0].status == 'ok') {

                            window.toastr.success('Arquivo encaminhado para processamento!')
                            return false

                        } else {

                            window.toastr.error('Ocorreu um problema, por favor contacte o administrador do sistema')
                            return false

                        }

                    }).catch((err) => {

                        console.log(err.response)

                    })
                    
                    

                },
		        Cancelar: function () {
		            //$.alert('Canceled!');
		        }

            },

        });


    }


    async function carregaDados() {

        //console.log(ano, '!?')

        await api.get(`desafioClimaPlanilha/${adesao_institucional_id}/${ano}`).then((result) => {

            console.log(result.data)
            
            var data = result.data[0]

            if (data) {


                var statusProcessamentoArquivoTemp = data.statusProcessamentoArquivo

                switch (statusProcessamentoArquivoTemp) {

                    case 'P':
                        var statusProcessamentoArquivoTemp_descri = 'Pendente'
                        break

                    case 'V':
                        var statusProcessamentoArquivoTemp_descri = 'Processado'
                        break

                }

                setHospClima_id(data.hospClima_id)
                
                setTipoInventario(data.tipoInventario)
                setNomeArquivo(data.nomeArquivo)
                setStatusProcessamentoArquivo(statusProcessamentoArquivoTemp_descri)


            }

        }).catch((err) => {

            console.log(err.response)

        })


    }




    function enviaPlanilha() {


        if (file == '') {

            window.toastr.error('Arquivo inválido!')
            return false

        } else {

            //var file_array = file.split('.')


        }


        window.$.confirm({
			//icon: 'fa fa-question',
            theme: 'material',
            closeIcon: true,
            animation: 'scale',
            type: 'blue',
		    title: 'Confirmação',
		    content: 'Confirma salvar?',
		    buttons: {
		        Sim: function () {

                    

                    const formData = new FormData();
                    const imagefile = document.querySelector("#planilhaDesafioClima");

                    

                    // 'fileimage' é o campo que o 'multer' procura o arquivo de imagem.
                    formData.append("planilha", imagefile.files[0]);
                    formData.append("tipoInventario", tipoInventario); // string junto ao formData.
                    
                    //console.log('altera')
                    //return false

                    axios.post(`${linkAPI}desafioClimaPlanilha/${adesao_institucional_id}/${ano}`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        'x-access-token': '!nf0$@ud#2',
                    }
                    }).then(response => {

                        console.log(response.data)
                        //setImagem(response.data.imagem)
                        //setFile('')
                        //setAtualizacaoGestao(moment().format('YYYY-MM-DD HH:mm:ss'))
                        setNomeArquivo(response.data.arquivoImportado)
                        setStatusProcessamentoArquivo('Pendente')
                        setFile('')

                        //window.toastr.success('Salvo com sucesso!')

                        window.$.confirm({
                            //icon: 'fa fa-question',
                            theme: 'material',
                            closeIcon: true,
                            animation: 'scale',
                            type: 'green',
                            title: 'Obrigado!',
                            content: 'Aguarde o processamento da planilha!',
                            buttons: {
                                Ok: function () {

                                }
                
                            },
                
                        });



                    }).catch((err) => {

                        console.log(err.response)

                    })


                    
                    

                },
		        Cancelar: function () {
		            //$.alert('Canceled!');
		        }

            },

        });


    }


    function downloadPlanilhaGHG() {


        if (nomeArquivo) {


            window.location.href = `${process.env.REACT_APP_API}/uploads/desafioClima/${nomeArquivo}`


        }



    }


    useEffect(() => {

        setHospClima_id('')
        setTipoInventario('')
        setNomeArquivo('')
        setStatusProcessamentoArquivo('Não enviado')

        carregaDados()


    }, [ano, adesao_institucional_id])




    return (


        <div>


            <div style={{ display: hospClima_id ? 'none' : 'block'}} >

            Por favor, preencha os Dados de ações de liderança e resiliência primeiro!

            </div>


            
            <div style={{ display: hospClima_id ? 'block' : 'none'}} >


                        <div className="row">

                            <div className="col-md-3">
                                <div class="form-group" >
                                    <label className="control-label">
                                        <Link style={{ color: questao1 }} onClick={() => {setEnunciado('Tipo de inventário');setSecaoEnunciado('Emissões de GEE');window.$('#modalValidacao').modal('show')}}>
                                            Tipo de inventário:
                                        </Link>
                                        
                                        </label>
                                    <select className="form-control" style={{ 'background-color': '#efefef'}} value={tipoInventario} onChange={event => setTipoInventario(event.target.value)}>
                                        <option value="">[Selecione]</option>
                                        <option value="B">Conteúdo Básico</option>
                                        <option value="A">Conteúdo Avançado</option>
                                    </select><br/>
                                        

                                </div>
                            </div>

                            <div className="col-md-6">
                                <div class="form-group" >
                                    <label className="control-label">
                                        
                                        <Link style={{ color: questao2 }} onClick={() => {setEnunciado('Planilha atual');setSecaoEnunciado('Emissões de GEE');window.$('#modalValidacao').modal('show')}}>
                                            Planilha atual:
                                        </Link>
                                        
                                        
                                    </label>
                                    <input type="text" className="form-control" value={nomeArquivo} readOnly style={{ cursor: nomeArquivo ? 'pointer' : 'auto'}} onClick={() => downloadPlanilhaGHG()} />
                                        

                                </div>
                            </div>

                            <div className="col-md-3">
                                <div class="form-group" >
                                    <label className="control-label">Status:</label>
                                    <input type="text" className="form-control" id="statusPlanilha" value={statusProcessamentoArquivo} disabled />
                                        

                                </div>
                            </div>

                            <div className="col-md-12" style={{ display: 'none'}}>
                                <div class="form-group" >
                                    <label className="control-label">Fazer o upload da PLANILHA "FERRAMENTA GHG Protocol v{ano}":</label>
                                    <input type="file" className="form-control" id="planilhaDesafioClima" value={file} onChange={event => setFile(event.target.value)} />
                                        

                                </div>
                            </div>


                            <div className="col-md-12">
                                <div align="center">
                                    <br/>
                                    <button type="button" className="btn btn-info" onClick={() => processaPlanilhaGHG()} >Processar planilha</button>
                                </div>
                            </div>
                    
                    </div>

                    <StatusValidacaoSecao desafio="Clima" secaoCampo="secaoDadosEmissoes" totalPendencias={totalPendencias} nomeDesafio="Desafio Clima" formulario_id={hospClima_id} secao="Emissões" adesao_institucional_id={adesao_institucional_id} ano={ano} />
                    
                </div>

        </div>

    )

}


export default ClimaPlanilha